import script from "./Loading.vue?vue&type=script&setup=true&lang=js"
export * from "./Loading.vue?vue&type=script&setup=true&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=2bdea380&scoped=true&lang=css"

import exportComponent from "C:\\xampp8\\htdocs\\arm_analysis_2025_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bdea380"]])

export default __exports__